import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminCategoriesApi } from '../api';
import { useTelegram } from '../hooks/useTelegram';
import './AdminCategoryEditPage.css';

export const AdminCategoryCreatePage: React.FC = () => {
  const navigate = useNavigate();
  const { tg } = useTelegram();

  const [saving, setSaving] = useState(false);

  // Form fields
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [isActive, setIsActive] = useState(true);

   
  useEffect(() => {
    // Show back button
    if (tg?.BackButton) {
      tg.BackButton.show();
      tg.BackButton.onClick(handleBack);
    }

    return () => {
      if (tg?.BackButton) {
        tg.BackButton.hide();
        tg.BackButton.offClick(handleBack);
      }
    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tg]);

  const handleBack = () => {
    navigate('/admin/categories');
  };

  const handleSave = async () => {
    // Validation
    if (!name.trim()) {
      tg?.showAlert('Введите название категории');
      return;
    }
    if (!description.trim()) {
      tg?.showAlert('Введите описание категории');
      return;
    }

    try {
      setSaving(true);

      // Create category (sort_order will be auto-assigned)
      await adminCategoriesApi.createCategory({
        name: name.trim(),
        description: description.trim(),
        is_active: isActive,
      });

      if (tg?.HapticFeedback) {
        tg.HapticFeedback.notificationOccurred('success');
      }

      tg?.showAlert('Категория успешно создана', () => {
        // Navigate back to categories list
        navigate('/admin/categories', { replace: true });
      });
    } catch (err: unknown) {
      tg?.showAlert(err instanceof Error ? err.message : 'Ошибка создания категории');

      if (tg?.HapticFeedback) {
        tg.HapticFeedback.notificationOccurred('error');
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="page admin-category-edit-page">
      <div className="admin-category-edit-header">
        <h1 className="admin-category-edit-title">Создание категории</h1>
      </div>

      <div className="admin-category-edit-content">
        {/* Basic Information */}
        <div className="admin-category-edit-section">
          <h2 className="admin-category-edit-section-title">Основная информация</h2>

          <div className="admin-category-edit-form-field">
            <label htmlFor="name">Название *</label>
            <input
              id="name"
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Например: Пельмени"
              disabled={saving}
            />
          </div>

          <div className="admin-category-edit-form-field">
            <label htmlFor="description">Описание *</label>
            <textarea
              id="description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              placeholder="Краткое описание категории"
              rows={3}
              disabled={saving}
            />
          </div>

          <div className="admin-category-edit-form-field checkbox-field">
            <label htmlFor="is_active" className="checkbox-label">
              <input
                id="is_active"
                type="checkbox"
                checked={isActive}
                onChange={(e) => setIsActive(e.target.checked)}
                disabled={saving}
              />
              <span>Категория активна</span>
            </label>
            <span className="admin-category-edit-field-hint">
              Неактивные категории не отображаются в каталоге
            </span>
          </div>
        </div>

        {/* Save Button */}
        <div className="admin-category-edit-actions">
          <button
            className="admin-category-edit-save-btn"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? 'Создание...' : 'Создать категорию'}
          </button>
        </div>
      </div>
    </div>
  );
};
